import { ProgressBar, PROGRESSBAR_VALIDATION } from "../../../components/progressbar/ProgressBar";
import { forEach } from "jszip";
import { useMemo } from "react";


export const LISITopProgressBars = ({ criteria, pieceInserted }) => {

  const BAR_SPACE_HEIGHT = 70;

  const [isAnalyzing, indicatorValue] = useMemo(() => {
    let isAnalyzing = false;
    let value = 0;
    criteria.forEach((criterion) => {
      if (criterion.value > criterion.threshold)
        value += criterion.weight;
      if (criterion.value > 0)
        isAnalyzing = true;
    });
    return [isAnalyzing, value];
  }, [criteria]);

  const borderColor = pieceInserted ? 'blink-border' : 'border-gray-300';

  return (
    <div className="h-full flex flex-col gap-4">
      <style>{`
        @keyframes blinkBorder {
          0%, 100% { border-color: #2CEAA8; }
          50% { border-color: #d1d5db; }
        }
        .blink-border {
          animation: blinkBorder 0.25s ease-in-out infinite;
        }
      `}</style>

      <div className={`h-2/3 border-4 rounded-md p-4 relative ${borderColor}`}>
        <div className="relative text-2xl">
          {
            [...criteria].sort((c1, c2) => c2.value - c1.value).map((criterion, criterionIndex) => {
              const top = criterionIndex * BAR_SPACE_HEIGHT;

              return (
                <div
                  key={criterion.name}
                  className="absolute w-full transition-all duration-500 ease-in-out"
                  style={{ top: `${top}px`, height: BAR_SPACE_HEIGHT }}
                >
                  {criterion.name}
                  <ProgressBar value={criterion.value} height="h-8" bgColor="white" color={PROGRESSBAR_VALIDATION} />
                </div>
              );
            })
          }
        </div>
      </div>

      <div className="h-1/3 p-4 text-5xl flex flex-col items-center justify-center">
        <div className="text-2xl">Niveau de confiance :</div>

        {!isAnalyzing ?
          <div>Aucune analyse en cours</div>
          : indicatorValue >= 5 ?
            <div className="text-success">Bon</div>
            : indicatorValue >= 3 ?
              <div className="text-yellow-500">Moyen</div>
              :
              <div className="text-error">Mauvais</div>
        }
      </div>

    </div>
  );
};